const SMALL_WORDS = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

const BIG_WORDS = new RegExp(
  '^(GPFA|GS|OGS|NIH|NSF|USDA|UC|DOE|EPA|NSA|NASA|DOD|USDI|USA|DN|PHS|USGS|VA|USDJ|DFA|US|EU|CA|NIFA|ARS|RA|CIRM|' +
  'DHCS|DARPA|ONR|CDC|HQ|CHRP|CIEE|USDS|USAID|CRDF|OREF|AHRQ|PPD|NCI|NARSAD|AFOSR|IES|NEH|NIMH|NOAA|AIDS|HIV|UCD|' +
  'UCLA|UCB|UCI|UCSB|UCSC|UCM|UCSD|UCR|LS|II|III|IV|VI|VII|VIII|IX|XI|XII|XIII|CBS|SOM|CIPIC|FS|CGIAR|PP|SS|MPS|' +
  'VC|GM|MSSP|VP|SPC|CNCR|UR|IET|ORU|DaFIS|TV|CH|CP|WRC|MU|CS|SA|UM|ER|PCS|PCL|ICU|PCN|BM|UCDMC|APS|HACS|EAOP|UCOP|' +
  'VMTRC|CAHFS|PSA|TR|DCDE|IR|DCAS|LLC|CV|CVA|CIA|FBI|IBMEC|NIC|SVT|JGC|CPI|GSK|SCUSD|HGT|ALCMI|UCCE|NICHD|SIS|PBMTC|' +
  'CCAH|IGERT|UCSF|PCT|AMC|PTC|ABA|MCTG|CTA|IFT|CTSU|ECOG|SWOG|CTSC|PAEA|CALFED|NIAID|MEXT|JCCHD|CIHR|NACHRI|NBER|' +
  'BIRCWH|IGA|USAMRAA|DFMF|CTSC|EUSA|RBC|GPC|GWRDC|NIDA|PIMSA|FAZDD|EHIB|EH&S|A&PS|LPN1|NP1|GSHIP|NV|HS|OH|ITT|PA|' +
  'TN|TX|MN|UT|CA|SS|CC|PR|GED|CSU|EEE|GRE|SAT|LSDAS|AL|DP|AA|BS|AB|PhD|MA|MS|MFA|MBA|MPH|MAS|EDD|LLM|GAC|KY|' +
  'AC|MAT|ATC|GSR|TA|NRSA|NH|NMH|CBCRP|MFP|NPB|MCB|CITA|CIO|CNPRC|GAMP|SBE|MCT|GRFP|PFTF|PEP|QE|BYU|JC|CC|NY|SF|PRM)$',
  'i'
);

// For Irish name prefixes preserve the case
const PRESERVE_CASE = /^(Mc|O')[A-Z]/;

export const titleCase = (value: string): string => {
  return value
    .toLowerCase()
    .replace(/[A-Za-z0-9\u00C0-\u00FF]+(?:'[Ss])?[^\s-\(\)\/]*/g, (match: string, i: number, title: string) => {
      if (i > 0 &&
        i + match.length !== title.length &&
        SMALL_WORDS.test(match) && title.charAt(i - 2) !== ':' &&
        (title.charAt(i + match.length) !== '-' || title.charAt(i - 1) === '-') &&
        title.charAt(i - 1).search(/[^\s-\(\)\/]/) < 0
      ) {
        return match.toLowerCase();
      }

      if (BIG_WORDS.test(match)) {
        return match.toUpperCase();
      }

      if (PRESERVE_CASE.test(match)) {
        return match;
      }

      if (match.substr(1).search(/[A-Z]|\../) > -1) {
        return match;
      }

      return match.charAt(0).toUpperCase() + match.substr(1);
    });
};



// WEBPACK FOOTER //
// ./src/gs-core/common/convert/titleCase.ts